import request,{api} from '@/utils/request'

export function mailboxAdd(data) {
  return request('/mailbox/add', 'post', data)
}

export function uploadPlural(data) {
  return api({
    method: 'post',
    url: '/probity/upload/plural',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getImgCode(data) {
  return request('/mailbox/image/code', 'post', data)
}

// 获取登录-短信-图片验证码
export function postLogImg() {
  return request('/image/code', 'post')
}

// 获取登录手机验证码
export function getVerifyCode(data) {
  return request('/login/code', 'post', data)
}

// 登录
export function loginByMobile(data) {
  return api.post('/login/mobile', data)
}


// 信件列表查询
export function queryPage(data) {
  return request('/mailbox/queryPage', 'post', data)
}

// 信件明细查询
export function queryLetDetail(appealId) {
  return request(`/mailbox/detail/${appealId}`, 'post')
}

// 群众信件查询
export function queryMailForPublic(data) {
  return request('/mailbox/queryMailForPublic', 'post', data)
}

// 群众信件撤销
export function cancelMail(appealId) {
  return request(`/mailbox/cancel/${appealId}`, 'post')
}
